<ng-container *ngIf="user$ | async as _user">
  <div
    class="topbar-item"
    data-placement="bottom"
    ngbTooltip=" Quick user info"
    style="max-width: 190px; width: max-content"
  >
    <div
      class="btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2"
      id="kt_quick_user_toggle"
    >
      <div
        style="min-width: 100px"
        class="d-none d-md-flex flex-column align-items-start text-dark-50 font-size-base mr-2"
      >
        <div *ngIf="greeting" class="font-weight-bold">Welcome</div>
        <div class="font-weight-bolder ks-text-1lns no-hover">
          {{ ((_user.firstName || '') + ' ' + (_user.lastName || ''))?.trim() | titlecase }}
        </div>
      </div>
      <kt-user-photo
        [create]="false"
        [size]="40"
        [type]="'observable'"
        [editable]="false"
        [user$]="user$"
      ></kt-user-photo>
    </div>
  </div>
</ng-container>
